export default "__VITE_ASSET__CMNFWuxU__"